import { AlertTriangle } from 'lucide-react';
import SuperAdminLayout from '../../components/superadmin/SuperAdminLayout';

const NOTES = [
    {
        type: 'danger',
        title: 'Tuyệt đối không được sửa dữ liệu ảnh ở Cloudinary',
        content: 'Các shop có id 1, 12, 17, 26, 29 — KHÔNG được chỉnh sửa / xóa dữ liệu ảnh trên Cloudinary.',
    },
];

function NotesContent() {
    return (
        <div style={{ padding: '24px', maxWidth: 900, margin: '0 auto' }}>
            <h1 style={{ fontSize: 24, fontWeight: 700, marginBottom: 20 }}>Lưu ý</h1>

            {NOTES.map((note, index) => (
                <div
                    key={index}
                    style={{
                        display: 'flex',
                        gap: 16,
                        alignItems: 'flex-start',
                        background: '#fef2f2',
                        border: '1px solid #fecaca',
                        borderLeft: '4px solid #dc2626',
                        borderRadius: 8,
                        padding: 16,
                        marginBottom: 16,
                    }}
                >
                    <AlertTriangle style={{ color: '#dc2626', flexShrink: 0, marginTop: 2 }} />
                    <div>
                        <div style={{ fontWeight: 600, color: '#b91c1c', marginBottom: 4 }}>{note.title}</div>
                        <div style={{ color: '#7f1d1d', lineHeight: 1.6 }}>{note.content}</div>
                    </div>
                </div>
            ))}
        </div>
    );
}

export default function Notes() {
    return (
        <SuperAdminLayout>
            <NotesContent />
        </SuperAdminLayout>
    );
}
